import React from "react";
import { useTranslation } from "react-i18next";
import { CalendarDays, Check, Fish, Map, RefreshCw } from "lucide-react";
import "../styles/components/AppStartupOverlay.css";

const PROGRESS_BY_PHASE = {
  session: "38%",
  feed: "78%",
};

const STARTUP_STEPS = [
  { key: "maps", Icon: Map, complete: true },
  { key: "catches", Icon: Fish, complete: true },
  { key: "trips", Icon: CalendarDays, complete: true },
  { key: "syncing", Icon: RefreshCw, active: true },
];

export default function AppStartupOverlay({ phase = "session" }) {
  const { t } = useTranslation();
  const progressWidth = PROGRESS_BY_PHASE[phase] || PROGRESS_BY_PHASE.session;
  const statusMessage =
    phase === "feed"
      ? t("startup_loading_feed", {
          defaultValue: "Loading your feed...",
        })
      : t("startup_restoring_session", {
          defaultValue: "Restoring your session...",
        });

  return (
    <div className="app-startup-overlay" role="status" aria-live="polite">
      <div className="app-startup-overlay__watermark" aria-hidden="true" />
      <div className="app-startup-overlay__panel">
        <div className="app-startup-overlay__brand">
          <img
            className="app-startup-overlay__logo"
            src="/banner/logo.png"
            alt={t("startup_logo_alt", { defaultValue: "Reel It Pro logo" })}
          />
          <div>
            <p className="app-startup-overlay__wordmark">
              <span className="app-startup-overlay__wordmark-script">
                {t("navbar_mobile_brand_reel_it", { defaultValue: "Reel it" })}
              </span>
              <span className="app-startup-overlay__wordmark-pro">
                {t("navbar_mobile_brand_pro", { defaultValue: "PRO" })}
              </span>
            </p>
            <p className="app-startup-overlay__eyebrow">
              {t("startup_brand_eyebrow", {
                defaultValue: "REEL IT LIKE A PRO",
              })}
            </p>
          </div>
        </div>
        <h1 className="app-startup-overlay__title">
          {t("startup_title", {
            defaultValue: "Getting your next adventure ready",
          })}
        </h1>
        <p className="app-startup-overlay__subtitle">
          {t("startup_subtitle", {
            defaultValue: "Preparing maps, catches, and trips...",
          })}
        </p>
        <div className="app-startup-overlay__progress" aria-hidden="true">
          <div
            className="app-startup-overlay__progress-fill"
            style={{ width: progressWidth }}
          />
        </div>
        <p className="app-startup-overlay__status">{statusMessage}</p>
        <div className="app-startup-overlay__steps" aria-hidden="true">
          {STARTUP_STEPS.map(({ key, Icon, complete, active }) => (
            <div
              className={`app-startup-overlay__step${
                active ? " app-startup-overlay__step--active" : ""
              }`}
              key={key}
            >
              <span className="app-startup-overlay__step-icon">
                <Icon size={18} strokeWidth={2.35} />
                {complete ? (
                  <span className="app-startup-overlay__step-check">
                    <Check size={9} strokeWidth={3} />
                  </span>
                ) : null}
              </span>
              <span>{t(`startup_step_${key}`)}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
